/**
 * @generated SignedSource<<de0ff5e4b5074038a5fcbc43bef0ae7e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DrawingSetAnnotationCreateInput = {
  createdAt?: number | null | undefined;
  createdById?: string | null | undefined;
  drawingSetId: string;
  drawingSheetId: string;
  id?: string | null | undefined;
  type: string;
  updatedAt?: number | null | undefined;
  xfdf: string;
};
export type createDrawingSetAnnotationMutation$variables = {
  input: DrawingSetAnnotationCreateInput;
};
export type createDrawingSetAnnotationMutation$data = {
  readonly createDrawingSetAnnotation: {
    readonly cursor: string;
    readonly node: {
      readonly " $fragmentSpreads": FragmentRefs<"drawingSetAnnotationFragment">;
    };
  };
};
export type createDrawingSetAnnotationMutation = {
  response: createDrawingSetAnnotationMutation$data;
  variables: createDrawingSetAnnotationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createDrawingSetAnnotationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetAnnotationEdge",
        "kind": "LinkedField",
        "name": "createDrawingSetAnnotation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DrawingSetAnnotation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "drawingSetAnnotationFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createDrawingSetAnnotationMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DrawingSetAnnotationEdge",
        "kind": "LinkedField",
        "name": "createDrawingSetAnnotation",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "DrawingSetAnnotation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdById",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "drawingSetId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "drawingSheetId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "xfdf",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0d65ba0425e29d8aeb9ee27366bdafd1",
    "id": null,
    "metadata": {},
    "name": "createDrawingSetAnnotationMutation",
    "operationKind": "mutation",
    "text": "mutation createDrawingSetAnnotationMutation(\n  $input: DrawingSetAnnotationCreateInput!\n) {\n  createDrawingSetAnnotation(input: $input) {\n    cursor\n    node {\n      ...drawingSetAnnotationFragment\n      id\n    }\n  }\n}\n\nfragment drawingSetAnnotationFragment on DrawingSetAnnotation {\n  id\n  createdAt\n  updatedAt\n  createdById\n  drawingSetId\n  drawingSheetId\n  type\n  xfdf\n}\n"
  }
};
})();

(node as any).hash = "118af2f7e4230740fa9d56f45589b46e";

export default node;
